// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ListItemAvatarAndContent-base__RJZbw{display:flex;flex:1 1 0;flex-direction:row;gap:var(--size-3);align-items:flex-start;min-width:0}.ListItemAvatarAndContent-avatarSlot__U88Dy{display:flex;flex-direction:column;flex-shrink:0;align-items:flex-start;justify-content:center;min-height:var(--size-10);padding:var(--size-0_5) 0}.ListItemAvatarAndContent-contentSlot__bAdn7{display:flex;flex:1 0 0;flex-direction:column;align-items:flex-start;justify-content:center;min-width:0;min-height:var(--size-10)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "ListItemAvatarAndContent-base__RJZbw",
	"avatarSlot": "ListItemAvatarAndContent-avatarSlot__U88Dy",
	"contentSlot": "ListItemAvatarAndContent-contentSlot__bAdn7"
};
export default ___CSS_LOADER_EXPORT___;
